import { render, staticRenderFns } from "./InitPanel.vue?vue&type=template&id=618ae9c0&scoped=true"
import script from "./InitPanel.vue?vue&type=script&lang=js"
export * from "./InitPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ae9c0",
  null
  
)

export default component.exports